import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIList from 'UIComponents/list/UIList';
import ToolDescription from './ToolDescription';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ListToolsContent = ({
  hasListsWriteScope,
  hasListsViewScope,
  onImportOptOutClick,
  onManageAllowlistingClick,
  showMissingListScopeTooltip,
  staticListLimitReached
}) => {
  const disabled = !hasListsViewScope || !hasListsWriteScope || staticListLimitReached;
  return /*#__PURE__*/_jsxs(UIList, {
    children: [showMissingListScopeTooltip( /*#__PURE__*/_jsxs(UIButton, {
      "data-test-id": "import-opt-out-button",
      disabled: disabled,
      onClick: onImportOptOutClick,
      children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "EmailComponents.manage.moreTools.importOptOut"
      }), /*#__PURE__*/_jsx(ToolDescription, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "EmailComponents.manage.moreTools.importOptOutDescription"
        })
      })]
    }), true), /*#__PURE__*/_jsxs(UIButton, {
      onClick: onManageAllowlistingClick,
      children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "EmailComponents.manage.moreTools.allowListing"
      }), /*#__PURE__*/_jsx(ToolDescription, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "EmailComponents.manage.moreTools.allowListingDescription"
        })
      })]
    })]
  });
};
export default ListToolsContent;